const styles = ({ layout, palette }) => ({
  ...layout,
});

export default styles;
